import Dropdown from '@stories/Components/Inputs/Dropdown/Dropdown';
import * as React from 'react';
import FS from '../FieldShared.styles';
const SelectField = ({ dirty, error, inputProps, label, type = 'select', readOnly = false, placeholder, required, children, selectRef, }) => {
    return (React.createElement(FS.Container, { "data-type": type, "data-dirty": dirty, "data-valid": dirty && !error, "data-invalid": dirty && !!error },
        React.createElement(FS.Label, { htmlFor: inputProps.name },
            label,
            required ? '*' : ''),
        React.createElement(Dropdown, { ...inputProps, id: inputProps.name, disabled: readOnly, hasError: error ? true : false, ...(selectRef ? { ref: selectRef } : {}) },
            placeholder && (React.createElement("option", { hidden: true, value: "" }, placeholder)),
            children),
        error && React.createElement(FS.Error, null, error.message)));
};
export default SelectField;
